import { useMutation } from "@tanstack/react-query";

import { queryClient } from "@config/queryClient";
import useMeetingStore from "@store/useMeetingStore";
import meetingService from "@services/meeting.service";
import ToastService from "@services/toast.service";
import { ERROR_STRINGS } from "@config/messages";
import { useBugsnagErrorHandler } from "@hooks/useBugsnagErrorHandler";
import { DisconnectedError } from "@app-types/errors";
import { MEETING_QUERY_KEY, SYNC_MEETING_MUTATION_KEY } from "@config/query";

export function useSyncMeeting(onError?: () => void) {
  const { notifyBugsnag } = useBugsnagErrorHandler();
  const { setMeetingId } = useMeetingStore();

  return useMutation({
    mutationKey: [SYNC_MEETING_MUTATION_KEY],
    mutationFn: async ({
      itemId,
      calendarId,
    }: {
      itemId: string;
      calendarId?: string | null;
    }) => {
      return await meetingService.syncMeeting(itemId, calendarId);
    },
    onSuccess: (response, { itemId }) => {
      setMeetingId(response.meeting?.id ?? null);
      queryClient.setQueryData([MEETING_QUERY_KEY, itemId], response);
      ToastService.showSuccess("Meeting Synced");
    },
    onError: (error) => {
      if (error instanceof DisconnectedError) return;
      notifyBugsnag(error, ERROR_STRINGS.SYNC_MEETING);
      onError?.();
    },
  });
}
